import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { getDeviceTypeTranslationKey } from '../device-type-functions';
import { MmuDeviceProductGroup } from '../models/device-product-group';
import { MmuDeviceType } from '../models/device-type';


@Pipe({
  name: 'deviceTypeLabel'
})
export class MmuDeviceTypeLabelPipe implements PipeTransform {
  constructor(private _translate: TranslateService) {
  }

  transform(value: MmuDeviceProductGroup | MmuDeviceType, fallback = 'unknown'): string | null {
    const translationString = getDeviceTypeTranslationKey(value, fallback);
    return this._translate.instant(`types.${translationString}`);
  }
}
